import React from "react";
import { ToastContainer, Toast, CloseButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface ToastProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  text: string;
}

const ToastComponent: React.FC<ToastProps> = ({ show, setShow, text }) => {
  const { t } = useTranslation();
  return (
    <ToastContainer
      position="bottom-center"
      className="position-fixed"
      style={{ zIndex: 1050 }}
    >
      <Toast
        role="status"
        aria-live="polite"
        onClose={() => setShow(false)}
        show={show}
        delay={3000}
        autohide
        className="bg-text-primary w-auto m-3"
      >
        <Toast.Body className="d-flex justify-content-between align-items-center py-3 px-4 fs-18 fw-normal ">
          {text && <span className="mb-0 text-white">{t(text)}</span>}
          <CloseButton
            onClick={() => setShow(false)}
            style={{ lineHeight: "150%" }}
            variant="white"
            className="fs-16 ms-4 text-white opacity-100 shadow-none"
            aria-label={t("Close notification")}
          />
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default ToastComponent;
